import React from "react";
import {
  Table,
  Badge,
  Button,
  OverlayTrigger,
  Tooltip,
  Form,
} from "react-bootstrap";
import {
  IconEdit,
  IconTrash,
  IconPhoto,
  IconCalendar,
  IconEye,
} from "@tabler/icons-react";

const ProductTable = ({ 
  products, 
  onEdit, 
  onDelete, 
  onViewImages,
  selectedProducts = [],
  selectAll = false,
  onSelectProduct,
  onSelectAllProducts
}) => {
  const handleViewImages = (product) => {
    if (onViewImages) {
      onViewImages(product);
    }
  };

  return (
    <Table responsive hover className="products-table">
      <thead>
        <tr>
          {onSelectProduct && (
            <th style={{ width: "50px" }}>
              <Form.Check
                type="checkbox"
                checked={selectAll}
                onChange={onSelectAllProducts}
                title="Selecionar todos"
              />
            </th>
          )}
          <th>Nome do Produto</th>
          <th>Agente</th>
          <th>Valor</th>
          <th>Imagens</th>
          <th>Data de Criação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {products.map((product) => (
          <tr key={product.id}>
            {onSelectProduct && (
              <td>
                <Form.Check
                  type="checkbox"
                  checked={selectedProducts.includes(product.id)}
                  onChange={() => onSelectProduct(product.id)}
                />
              </td>
            )}
            <td>
              <div>
                <div className="fw-bold">{product.name}</div>
                {product.description && (
                  <small className="text-muted">
                    {product.description.length > 50
                      ? `${product.description.substring(0, 50)}...`
                      : product.description}
                  </small>
                )}
              </div>
            </td>
            <td>
              <div className="fw-bold text-capitalize">
                {product.agentName}
              </div>
            </td>
            <td>
              <div className="">
                {product.formattedValue}
              </div>
            </td>
            <td>
              <div className="d-flex align-items-center">
                <IconPhoto size={14} className="me-1 text-muted" />
                <span className={product.hasImages ? "text-success" : "text-muted"}>
                  {product.imageCount}
                </span>
                {product.hasImages && onViewImages && (
                  <Button
                    variant="link"
                    size="sm"
                    className="p-0 ms-2"
                    onClick={() => handleViewImages(product)}
                  >
                    <IconEye size={14} />
                  </Button>
                )}
              </div>
            </td>
            <td>
              <div className="d-flex align-items-center">
                <IconCalendar size={14} className="me-1 text-muted" />
                <span className="date-info">
                  {product.formattedCreatedAt}
                </span>
              </div>
            </td>
           
            <td>
              <div className="d-flex gap-1">
                <OverlayTrigger
                  overlay={<Tooltip>Editar produto</Tooltip>}
                >
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => onEdit(product.id)}
                  >
                    <IconEdit size={14} />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={<Tooltip>Excluir produto</Tooltip>}
                >
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onDelete(product)}
                  >
                    <IconTrash size={14} />
                  </Button>
                </OverlayTrigger>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProductTable;